import React, { useState, useEffect, useRef, useImperativeHandle, forwardRef } from 'react';

const TextEditor = forwardRef((props, ref) => {
  const { value } = props;
  const [inputValue, setInputValue] = useState(value);
  const inputRef = useRef(null);

  useEffect(() => {
    const stopPropagation = event => {
      event.stopPropagation();
    };

    if (inputRef.current) {
      inputRef.current.addEventListener('click', stopPropagation);
    }

    return () => {
      if (inputRef.current) {
        inputRef.current.removeEventListener('click', stopPropagation);
      }
    };
  }, []);

  useImperativeHandle(ref, () => ({
    getValue: () => inputValue,
    isCancelAfterEnd: () => inputValue === value,
  }));

  return (
    <input
      ref={inputRef}
      className="ag-cell-edit-input"
      onChange={event => setInputValue(event.target.value)}
      type="text"
      value={inputValue}
    />
  );
});

export default TextEditor;
